import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutRevenueCodeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    panelRevenueCode: Panel;
    sourceEdiCrossRefRevenueCode: DataSource;
    tableCrossRef: Table;
}
